class SaveFCMTokenRequest {
    constructor() {
        this.user_Id = 0;
        this.fcmToken = "";
        this.deviceType = "";
    }
}

export default SaveFCMTokenRequest;